module.exports = __webpack_public_path__ + "static/img/143ded79-db77-4f2e-b612-d333f9ce4aca.a42c4f08.png";